import React from 'react';
import { Search } from '@naf-simba/building-blocks-icons/General';
import { Loader } from '@naf-simba/building-blocks-loaders';
import useSelector from '../../../redux/typedHooks';
import { NavbarLink } from '../NavbarLink/NavbarLink';
import { DesktopMenuButton } from '../DesktopMenuButton/DesktopMenuButton';
import LogoArea from '../LogoArea/LogoArea';
import MemberArea from '../MemberArea/MemberArea';
import { NavigationButtons } from '../../MegaMenuOverlay/NavigationButtons/NavigationButtons';
import { NavbarProps } from '../Navbar.types';
import * as S from './DesktopNavbar.styles';

const DesktopNavbar = ({
  onNavClick,
  onHamburgerMenuClick,
  onProfileMenuClick,
  onSearchClick,
  showProfileMenu,
  setShowProfileMenu,
  isAuthenticated,
  isMyNAFEnabled,
  isLoading,
  isSearchEnabled,
  accountName,
  isMenuOpen,
}: NavbarProps) => {
  const navbarItems = useSelector((state) => state.globalSettings.settings?.navigationBar?.items);

  return (
    <S.TopBar $isMenuOpen={isMenuOpen}>
      <LogoArea onNavClick={onNavClick} />
      <S.TopBarItems>
        {navbarItems?.slice(0, 3).map((link, index) => (
          <NavbarLink item={link} key={link?.header ?? index} />
        ))}
        <S.ExtraNavbarLinks>
          {navbarItems?.slice(3).map((link, index) => (
            <NavbarLink item={link} key={link?.header ?? index} />
          ))}
        </S.ExtraNavbarLinks>
        <DesktopMenuButton onClick={onHamburgerMenuClick} isMenuOpen={isMenuOpen} />
      </S.TopBarItems>
      <S.CustomerField>
        {isSearchEnabled && (
          <S.SearchButton
            type="button"
            aria-label="Søk"
            onClick={onSearchClick}
            size="small"
            startIcon={Search}
            textWrap="nowrap"
          >
            Søk
          </S.SearchButton>
        )}
        {isLoading && !isAuthenticated ? (
          <S.LoaderWrapper>
            <Loader size="small" />
          </S.LoaderWrapper>
        ) : (
          <MemberArea
            accountName={accountName}
            onProfileMenuClick={onProfileMenuClick}
            showProfileMenu={showProfileMenu}
            setShowProfileMenu={setShowProfileMenu}
            isAuthenticated={isAuthenticated}
            isMyNafEnabled={isMyNAFEnabled}
            isLoading={isLoading}
          />
        )}
        <S.NavigationButtonsWrapper>
          <NavigationButtons isLoggedIn={isAuthenticated} />
        </S.NavigationButtonsWrapper>
      </S.CustomerField>
    </S.TopBar>
  );
};

export default DesktopNavbar;
